import axios from 'axios';
import { Form, Modal, Tag } from "antd";
import { useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import Spinner from "@src/components/spinner";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { newScheduleTaskMutation } from "@src/util/mutation/scheduleTask.mutation";
import { updateScheduleCheckCallMutation } from "@src/util/mutation/scheduleChecks.mutation";
import { genericFileUploadSignatureMutation } from '@src/util/mutation/genericFileUpload.mutation';
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import { useDispatch } from "react-redux";
import dayjs from 'dayjs';
import { getCompletedScheduleTaskByTaskId } from '@src/util/query/siteTask.query';
import { getTaskInLibrary } from '@src/util/query/taskInLibrary.query';
import { GenerateNormalFields } from "@src/util/generateFields/generateNormalField";



export const SiteDutyTaskModal = ( {modalDetail, close, refetch=()=>{}, onSubmit=()=>{}} )=>{
    const {modal, siteTaskId, call} = modalDetail;

    const {data: taskDetail, loading:taskDetailLoading} = useQuery(getCompletedScheduleTaskByTaskId,{
        variables:{
            taskId:siteTaskId,
            scheduleId: call?.scheduleId,
            checkCallId: call?._id,
        },
        skip: !siteTaskId || !call?.scheduleId,
        fetchPolicy:'network-only'
    });

   
    const [taskData, setTaskData] = useState(null);
    useEffect(()=>{
        if(!taskDetailLoading && taskDetail?.getCompletedScheduleTaskByTaskId?.response){

            if(taskDetail?.getCompletedScheduleTaskByTaskId?.response){
                const task = taskDetail?.getCompletedScheduleTaskByTaskId?.response?.fields?.map((field)=>{
                    const d =  taskDetail?.getCompletedScheduleTaskByTaskId?.response?.attachment?.find(att=>att?.name === field?.name)?.value;
                    
                    
                    const isExist = taskDetail?.getCompletedScheduleTaskByTaskId?.response?.attachment?.find(att=>att?.name === field?.name);
                    
                    if(isExist){
                        return {
                            ...field,
                            value: isExist?.file,
                            fieldType: "file"
                        }
                    }

                    return field;
                });
                
                setTaskData(task)
            }

        }
    },[taskDetail?.getCompletedScheduleTaskByTaskId?.response, taskDetailLoading]);
    


    const {data: taskInLibraryData, loading: taskInLibraryLoading} = useQuery(getTaskInLibrary, {
        variables: {
            getTaskInLibraryId: siteTaskId
        },
        skip: !siteTaskId,
        fetchPolicy: 'network-only'
    });



    const [scheduleTaskDetail, setScheduleTaskDetail] = useState(null);

    useEffect(()=>{
        if(taskInLibraryData?.getTaskInLibrary?.response){
            setScheduleTaskDetail(taskInLibraryData?.getTaskInLibrary?.response);
        }
        else{
            setScheduleTaskDetail(null);
        }
    }, [taskInLibraryData?.getTaskInLibrary?.response, call?.sitecheckpointDetail]);
    
   
        
    const [field, setField] = useState([]);

    
    const handelDataValue = ({name, value})=>{
        if(name){
            if(value){
                const isExist = field?.find((f)=>f.name==name);
                
                if(isExist){

                    setField(field?.map((f)=>{
                        if(f.name==name){
                            return {
                                ...f,
                                value
                            }
                        }else{
                            return f;
                        }
                    }))
                }else{
                    
                    setField([...field, {name, value}])
                }
            }else{
                const isExist = field?.find((f)=>f.name==name);
                if(isExist){
                    setField(field?.map((f)=>{
                        if(f.name==name){
                            return {
                                ...f,
                                value:''
                            }
                        }else{
                            return f;
                        }
                    }))
                }else{
                    setField([...field, {name, value:''}])
                }
            }
        }
    };


    const [updateScheduleCheckCall, {loading: updateScheduleCheckCallLoading}] = useMutation(updateScheduleCheckCallMutation)

    const [newScheduleTask, {loading: newScheduleTaskLoading}] = useMutation(newScheduleTaskMutation);

    const [fileLoading, setFileLoading] = useState(false);

    const [genericFileUploadSignature, {loading: genericFileUploadSignatureLoading}] = useMutation(genericFileUploadSignatureMutation);
    const dispatch = useDispatch();

    const handelDutyTaskSubmit = async ()=>{
        try{

           

            let fieldInputs = [...field];

            if(field?.find((f)=>f?.value && f?.value?.size>0 && f?.value?.type)){
                
                await Promise.all(field?.filter((f)=>f?.value && f?.value?.size>0 && f?.value?.type)?.map(async(file)=>{

                    const filesName = "dutyreport/"+call?.scheduleId+"/"+call?._id+"-"+siteTaskId+"-"+file?.value?.name?.toLowerCase().replace(/\s+/g, '');

                    setFileLoading(true);
                    const fileUploadUrlsResponse = await genericFileUploadSignature({
                            variables:{
                                input: {
                                    fileName: filesName,
                                    objectType: 'dutyreport'
                                }
                            }
                    });

                    const fileUploadUrls = fileUploadUrlsResponse?.data?.genericFileUploadSignatureUrl?.response?.url;
                    
                    await axios.put(fileUploadUrls, file?.value,{
                        headers: {
                            'Content-Type': file?.value?.type ,
                            'Content-Length': file?.value?.size
                        },
                    });

                    fieldInputs = fieldInputs?.map((f)=>{
                        if(f.name==file?.name){
                            return {
                                ...f,
                                value: filesName,
                                fieldType: "file",
                            }
                        }else{
                            return f;
                        }
                    });
                    
                }))

            }
            
            
            await newScheduleTask({
                variables:{
                    input:{
                        siteId: call?.siteId,
                        taskId: siteTaskId,
                        scheduleId: call?.scheduleId,
                        fields: fieldInputs,
                        checkCallId: call?._id
                    }
                }
            })

            await updateScheduleCheckCall({
                variables:{
                    input: {
                        _id: call?._id,
                        fields: {
                            pending: false,
                            expired: true,
                            late: false,
                            actualDate: dayjs(),
                            callType: call?.callType,
                            scheduleId: call?.scheduleId,
                            reason: null,
                        }
                    }
                }
            });

            
            setFileLoading(false);


            dispatch(setNotification({
                error: false,
                notificationState: true,
                message: "Task was submitted successfully"
            }));

            close();

            await onSubmit();
        
        }catch(err){
            dispatch(setNotification(({
                error: true,
                notificationState: true,
                message: "Error encountered while submitting schedule task",
            })));
        }
    }

    useEffect(()=>{
        if(field?.length === 0 && scheduleTaskDetail?.fields?.length > 0){
            setField(scheduleTaskDetail?.fields?.map((prop)=>{
                return({
                    name: prop?.key || prop?.label?.replaceAll(" ","")?.toLowerCase(),
                    value: "",
                });
            }));
        }else if(field?.length === 0 && call?.sitecheckpointDetail?.fields?.length > 0){
            setField(call?.sitecheckpointDetail?.fields?.map((prop)=>{
                return({
                    name: prop?.key || prop?.label?.replaceAll(" ","")?.toLowerCase(),
                    value: "",
                });
            }));
        }
    },[scheduleTaskDetail?.fields, field, call?.sitecheckpointDetail?.fields]);

    const [isDisabled, setIsDisabled] = useState(true);
    
    useEffect(()=>{
        if(field?.length > 0){
            const isAllFieldsFilled = field?.every((f) => {
                const value = f?.value;
                if (!value || value?.length===0) return false;
                
                // File check
                if (value instanceof File) return value.size > 0;
                
                // Array check  
                if (Array.isArray(value)) {
                    return value.length > 0 && value.every(item => 
                        item instanceof File ? item.size > 0 : Boolean(item?.toString().trim())
                    );
                }
                
                // String check
                return value.toString().trim().length > 0;

            });
            setIsDisabled(!isAllFieldsFilled);
        }else{
            setIsDisabled(true);
        }
    },[field]);

    
   
    return(
        <Modal
            open={modal}
            width={700}
            style={{overflow:'auto'}}
            footer={
                taskData?
                null
                :
                <div className='drawer-footer' style={{display:'flex', alignItems:'center', justifyContent:'end'}}>
                    <button disabled={isDisabled || fileLoading || newScheduleTaskLoading || updateScheduleCheckCallLoading || genericFileUploadSignatureLoading} className={isDisabled || fileLoading || newScheduleTaskLoading || updateScheduleCheckCallLoading || genericFileUploadSignatureLoading?'disabled-btn drawer-filled-btn':'drawer-filled-btn'} onClick={handelDutyTaskSubmit}>
                        {fileLoading || newScheduleTaskLoading || updateScheduleCheckCallLoading || genericFileUploadSignatureLoading?
                            <Spinner />
                            : 
                            "Submit"
                        }
                    </button>
                    <button disabled={fileLoading || newScheduleTaskLoading || updateScheduleCheckCallLoading || genericFileUploadSignatureLoading} className={fileLoading || newScheduleTaskLoading || updateScheduleCheckCallLoading || genericFileUploadSignatureLoading?'disabled-btn dim-btn':'dim-btn'} onClick={close}>Cancel</button>
                    
                </div>
            }
            closable={false}
        >

            <>
            {/* <JourneyTimelineMap/> */}
                {/* {contextHolder} */}
                <div className='modal-header-title'>
                    <span>{scheduleTaskDetail?.label || call?.sitecheckpointDetail?.name}</span>
                    <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
                </div>

                {
                    taskInLibraryLoading?

                        <div style={{display:'flex', justifyContent:'center', alignContent:'center'}}>
                            <Spinner/>
                        </div>

                    :
                    

                        <Form style={{padding:'20px', overflowY:'auto', maxHeight:'500px'}}>
                            <label style={{fontSize:'15px', fontWeight:'bold'}}>{scheduleTaskDetail?.label}</label>

                            {
                                (scheduleTaskDetail?.fields || call?.sitecheckpointDetail?.fields)?.map((prop, index)=>{

                                    if(taskData && taskData?.length > 0){
                                        const data = taskData?.find((f)=>f?.name===(prop?.key||prop?.label?.toLowerCase()?.replaceAll(" ", "")))
                                       
                                        return(
                                            <div>
                                                <label style={{fontSize:'15px', fontWeight:'500' }}>{prop?.label}</label> <br/>
                                                {data?.fieldType === "file" ?
                                                    <div style={{width:'200px', height:'100px', marginTop:'10px' }}>
                                                        <img src={data?.value} alt={data?.name} style={{height:'100%', cursor:'pointer'}} onClick={()=>window.open(data?.value)}/>    
                                                    </div>
                                                    :

                                                    (data?.value && data?.value?.length > 0  && typeof(data?.value)=="object") ?
                                                    <div className='popoverdataitem'>
                                                        {data?.value?.map((d, i)=>{
                                                            return (
                                                                <Tag key={i}>
                                                                    {d?.toString()}
                                                                </Tag>
                                                            )
                                                        })}
                                                    </div>
                                                    :
                                                    <div className='popoverdataitem'>
                                                        {data?.value?.toString() || "No Value"}
                                                    </div>
                                                }
                                            </div>
                                        );

                                    }else{

                                        const {value, type} = field?.find((f)=>f.name===(prop.key || prop?.label?.replaceAll(" ", "")?.toLowerCase())) || {value: "", type: null};
                                      

                                        return (
                                            <GenerateNormalFields 
                                                label={prop?.label}
                                                name={prop?.key || prop?.label?.replaceAll(" ", "")?.toLowerCase()}
                                                fieldType={prop?.fieldType}
                                                handelDataValue={handelDataValue}
                                                property={prop}
                                                value={value}
                                                employee={false}
                                                isReporting={false}
                                                disabled={true}
                                            />
                                        )

                                    }
                                })
                            }

                           

                        </Form>

                        
                }
            </>

        </Modal>
    )
}